export const formatKeymap = (keymap: string): string => {
  if (!keymap) return '';

  // Convert to lowercase and split by '+'
  const parts = keymap
    .toLowerCase()
    .split('+')
    .map(part => part.trim());

  // Create a mapping for different key names
  const keyMapping: { [key: string]: string } = {
    control: 'ctrl',
    command: 'meta',
    cmd: 'meta',
    windows: 'meta',
    win: 'meta',
    option: 'alt',
    shift: 'shift',
    return: 'enter',
    delete: 'backspace',
    esc: 'escape',
    space: ' ',
    plus: '+',
    minus: '-',
    up: 'arrowup',
    down: 'arrowdown',
    left: 'arrowleft',
    right: 'arrowright'
  };

  // Special characters mapping
  const specialCharacters: { [key: string]: string } = {
    period: '.',
    dot: '.',
    comma: ',',
    semicolon: ';',
    colon: ':',
    exclamation: '!',
    question: '?',
    at: '@',
    hash: '#',
    dollar: '$',
    percent: '%',
    caret: '^',
    ampersand: '&',
    asterisk: '*',
    underscore: '_',
    equals: '='
  };

  // Format each part of the key combination
  const formattedParts = parts.map(part => {
    part = part.replace(/\s+/g, '');

    // Check for modifier keys first
    if (keyMapping[part]) {
      return keyMapping[part];
    }

    // Check for special characters
    if (specialCharacters[part]) {
      return specialCharacters[part];
    }

    // If it's a single character, return as is
    if (part.length === 1) {
      return part;
    }

    // For function keys
    if (part.startsWith('f') && !isNaN(parseInt(part.slice(1)))) {
      return part;
    }

    return part;
  });

  // Sort modifiers to ensure consistent order (important for react-hotkeys-hook)
  const modifierOrder = ['ctrl', 'meta', 'alt', 'shift'];
  const modifiers = formattedParts.filter(part => modifierOrder.includes(part));
  const nonModifiers = formattedParts.filter(
    part => !modifierOrder.includes(part)
  );

  const sortedModifiers = modifiers.sort(
    (a, b) => modifierOrder.indexOf(a) - modifierOrder.indexOf(b)
  );

  // Combine all parts back together
  return [...sortedModifiers, ...nonModifiers].join('+');
};
